interface PageTitleProps {
    size?: "2xl" | "4xl";
    children?: React.ReactNode;
}

export default function PageTitle({ size = "4xl", children }: PageTitleProps) {
    const sizeClass = size === "2xl" ? "text-xl sm:text-2xl" : "text-2xl sm:text-4xl";
    return (
        <h1 className={`text-engage-500 ${sizeClass} font-bold block mb-4 text-center break-all`}>
            {children}
        </h1>
    );
}
